import { get, post } from "./http";

import axios from "axios";
import urlencode from "urlencode";
import baseUrl from "../utils/config.js";

const REPORT_URL_HOST = process.env.REPORT_URL_HOST;

// const apiUrl = process.env.NODE_ENV === 'development' ? baseUrl.devReportHost : baseUrl.proReportHost;
// const apiUrl = process.env.NODE_ENV === 'development' ? baseUrl.devApiHost : baseUrl.releaseApiHost;
let apiUrl = "";
switch (process.env.NODE_ENV) {
  case "development":
    apiUrl = baseUrl.devApiHost;
    break;
  case "release":
    apiUrl = baseUrl.releaseApiHost;
    break;
  case "tmkRelease":
    apiUrl = baseUrl.tmkReleaseApiHost;
    break;
  default:
    apiUrl = baseUrl.proApiHost;
}

export default {
  GetSupplierClass(search = "") {
    return get("api/Supplier/GetSupplierClass", {
      search
    });
  },

  GetSupplierList(
    token,
    search,
    type,
    page,
    recordCount,
    common = "1",
    key = ""
  ) {
    return get("api/Supplier/GetSupplierList", {
      token: token,
      search: search,
      type: type,
      page: page,
      recordCount: recordCount,
      common: common,
      key: key
    });
  },
  // 获取主档列表
  GetMainProfileList(
    token,
    Main_Category_Id,
    Category_Id,
    Sub_Category_Id,
    Name,
    Brand_Name,
    Model_Type,
    page,
    recordCount
  ) {
    return get("api/MainProfile/GetMainProfileList", {
      token,
      Main_Category_Id,
      Category_Id,
      Sub_Category_Id,
      Name,
      Brand_Name,
      Model_Type,
      page,
      recordCount
    });
  },
  //获取主档详情
  GetMainProfileInfo(token, ID) {
    return get("api/MainProfile/GetMainProfileInfo", {
      token,
      ID
    });
  },

  GetConstantValueList(
    data,
    customUrl = "http://192.168.3.9:8105/api/BaseData/GetConstantValueList"
  ) {
    const url =
      customUrl || "http://192.168.3.9:8105/api/BaseData/GetConstantValueList";
    return get(url, {
      data
    });
  },

  //批量上传供应商报价

  MultiImportMainProfilePrice(token, from) {
    return post("api/MainProfile/MultiImportMainProfilePrice", {
      token: token,
      data: from
    });
  },
  //创建供应商报价

  MainProfilePrice(token, from) {
    return post("api/MainProfile/MainProfilePrice", {
      token: token,
      data: from
    });
  },

  //GetCategoryList
  GetCategoryList(token, Filter, Status, IsTreeList) {
    return get("api/BaseData/GetCategoryList", {
      token,
      Filter,
      Status,
      IsTreeList
    });
  },

  //GetBaseDataList
  GetBaseDataList(token) {
    return get("api/BaseData/GetBaseDataList", {
      token
    });
  },

  CreateOrEditSupplier(token, from) {
    return post("api/Supplier/CreateOrEditSupplier", {
      token: token,
      data: from
    });
  },

  DeleteFile(token, from) {
    return post(`${apiUrl}api/Utils/SetAttachmentState`, {
      token: token,
      data: from
    });
  },
  GetDownloadUrl(token, id) {
    return `${apiUrl}api/Utils/DownloadAttachment?token=${token}&attid=${id}`;
  },

  GetUploadUrl(token, id, type) {
    return `${apiUrl}api/Utils/UploadAttachment?token=${token}&mtype=${type}&mid=${id}`;
  },

  // DownloadAttachment(token, id) {
  // 	return get('api/Utils/DownloadAttachment', {
  // 		token: token,
  // 		attid: id,
  // 	});
  // },

  GetGoodsTypeList(purchaseClass = "") {
    return get("api/Goods/GetGoodsTypeList", {
      purchaseClass
    });
  },

  GetGoodsList(
    token,
    search,
    type,
    common = "1",
    key = "",
    page = 1,
    recordCount = 30,
    ProjectID = 0
  ) {
    return get("api/Goods/GetGoodsList", {
      token,
      search,
      type,
      common,
      key,
      page,
      recordCount,
      ProjectID
    });
  },

  ExportGoodsList(token, search, type, common = "1", key = "") {
    return `${apiUrl}api/Goods/ExportGoodsList?token=${token}&search=${search}&type=${type}&common=${common}&key=${key}`;
    // return get('api/Goods/ExportGoodsList', {
    // 	token,
    // 	search,
    // 	type,
    // 	common,
    // 	key
    // });
  },

  CreateOrEditGoods(token, from) {
    return post("api/Goods/CreateOrEditGoods", {
      token: token,
      data: from
    });
  },

  BatchUpdateGoods(token, data) {
    return post("api/Goods/BatchUpdateGoods", {
      token,
      data
    });
  },

  CreateOrEditGoodsType(token, from) {
    return post("api/Goods/CreateOrEditGoodsType", {
      token: token,
      data: from
    });
  },

  GetStockinTypeList(token) {
    return get("api/Stock/GetStockinTypeList", {
      token: token
    });
  },

  GetStockOutTypeList(token) {
    return get("api/Stock/GetStockOutTypeList", {
      token: token
    });
  },

  GetWarehouseList(token) {
    return get("api/Stock/GetWarehouseList", {
      token: token
    });
  },

  GoodsStockIn(token, optime, optypeid, warehouseid, explain, detailList, mid) {
    return post("api/Stock/GoodsStockIn", {
      token: token,
      optime: optime,
      optypeid: optypeid,
      warehouseid: warehouseid,
      explain: explain,
      detailList: detailList,
      mid: mid
    });
  },

  GoodsStockOut(
    token,
    optime,
    optypeid,
    warehouseid,
    explain,
    detailList,
    mid
  ) {
    return post("api/Stock/GoodsStockOut", {
      token: token,
      optime: optime,
      optypeid: optypeid,
      warehouseid: warehouseid,
      explain: explain,
      detailList: detailList,
      mid: mid
    });
  },

  GetImportGoodsTemplate() {
    return get("api/Goods/GetImportGoodsTemplate", {});
  },

  MultiImportGoods(token, data) {
    return post("api/Goods/MultiImportGoods", {
      token: token,
      data: data
    });
  },

  GetSubscribeList(
    token,
    search,
    type,
    key,
    common,
    isOwn,
    page,
    recordCount,
    purid,
    projectID = ""
  ) {
    return get("api/Stock/GetSubscribeList", {
      token,
      search,
      type,
      key,
      common,
      isOwn,
      page,
      recordCount,
      purid,
      orderNum: projectID
    });
  },

  CreateOrEditSubscribe(token, data) {
    return post("api/Stock/CreateOrEditSubscribe", {
      token: token,
      data: data
    });
  },

  CreateProjectRequestOrder(token, data) {
    return post("api/Stock/CreateProjectRequestOrder", {
      token: token,
      data: data
    });
  },

  EditSubscribe(token, data) {
    return post("api/Stock/EditSubscribe", {
      token: token,
      data: data
    });
  },

  GetSubscribeInfo(token, id, ponum = "") {
    return get("api/Stock/GetSubscribeInfo", {
      token: token,
      id: id,
      ponum: ponum
    });
  },

  CancelSubscribeRecord(token, data) {
    return post("api/Stock/CancelSubscribeRecord", {
      token: token,
      data: data
    });
  },

  GetPurchaseList(
    token,
    search,
    type,
    common = "",
    isOwn = "",
    page = 1,
    recordCount = 50
  ) {
    return get("api/Stock/GetPurchaseList", {
      token,
      search,
      type,
      common,
      isOwn,
      page,
      recordCount
    });
  },

  GetPurchaseSupplierList(startDt, endDt, purid, purchaseType = "Local") {
    return get("api/Stock/GetPurchaseSupplierList", {
      startDt,
      endDt,
      purid,
      purchaseType
    });
  },

  GetPurchaseRequestList(
    token,
    startDt,
    endDt,
    purid,
    deptid,
    custidList,
    status,
    purchaseType,
    projectID,
    page,
    recordCount
  ) {
    return post("api/Stock/GetPurchaseRequestList", {
      token,
      startDt,
      endDt,
      purid,
      deptid,
      custidList,
      status,
      purchaseType,
      projectID,
      page,
      recordCount
    });
  },

  PreviewPurchaseRequestList(
    token,
    prePurIDList,
    purid,
    custList,
    purchaseType = "Local"
  ) {
    return post("api/Stock/PreviewPurchaseRequestList", {
      token,
      prePurIDList,
      purid,
      custList,
      purchaseType
    });
  },

  CreateOrEditPurchase(token, data) {
    return post("api/Stock/CreateOrEditPurchase", {
      token,
      data
    });
  },

  GetPurchaseInfo(token, id, ponum) {
    return get("api/Stock/GetPurchaseInfo", {
      token,
      id,
      ponum
    });
  },

  GetApprovalList(token, data) {
    return post("api/Stock/GetApprovalList", {
      token: token,
      data: data
    });
  },

  GetMyApprovalList(
    token,
    search,
    type,
    common,
    key,
    orderNum = "",
    page = 1,
    recordCount = 30
  ) {
    return get("api/Approval/GetMyApprovalList", {
      token,
      search,
      type,
      common,
      key,
      orderNum,
      page,
      recordCount
    });
  },

  ApprovalRequest(token, appid, remark, disagreereason, status) {
    return post("api/Approval/ApprovalRequest", {
      token,
      appid,
      remark,
      status,
      disagreereason
    });
  },

  GetAllowDepartByUser(token) {
    return get("api/Approval/GetAllowDepartByUser", {
      token
    });
  },

  ItemApproval(token, appid, status) {
    return post("api/Approval/ItemApproval", {
      token,
      appid,
      status
    });
  },

  GetGoodsInfo(token, id, qr = "", num = "") {
    return get("api/Goods/GetGoodsInfo", {
      token,
      id,
      qr,
      num
    });
  },

  CreateOrEditGoodsConvert(token, data) {
    return post("api/Goods/CreateOrEditGoodsConvert", {
      token,
      data
    });
  },

  SetCategoryApprovalStep(token, data) {
    return post("api/Approval/SetCategoryApprovalStep", {
      token,
      data
    });
  },

  GetSupplierInfo(token, custid) {
    return get("api/Supplier/GetSupplierInfo", {
      token,
      custid
    });
  },

  NotifyApproval(token, orderType, orderId) {
    return get("api/Approval/NotifyApproval", {
      token,
      orderType,
      orderId
    });
  },

  getmailid(url, maildata) {
    return post(url, maildata);
  },

  EditGoodsType(token, data) {
    return post("api/Goods/EditGoodsType", {
      token,
      data: data
    });
  },

  InvalidPurchaseInfo(token, ponum, id) {
    return post("api/Stock/InvalidPurchaseInfo", {
      token,
      ponum,
      id
    });
  },

  InvalidPurchaseOrder(token, id, status = 1) {
    return post("api/Stock/InvalidPurchaseOrder", {
      token,
      data: {
        id: id,
        remark: "del",
        status
      }
    });
  },

  InvalidPurchaseRequestion(token, id) {
    return post("api/Stock/InvalidPurchaseRequestion", {
      token,
      data: {
        id: id,
        remark: "del"
      }
    });
  },

  DeletePurchaseRequestionItem(token, id) {
    return post("api/Stock/DeletePurchaseRequestionItem", {
      token,
      data: {
        id,
        remark: "del"
      }
    });
  },

  /**
   * 获取出库单列表
   */
  getStockoutList(
    StockOutDateStart,
    StockOutDateEnd,
    MaterialName,
    Dyelno,
    Color,
    CJO,
    YardQTY,
    page = 1,
    recordCount = 30
  ) {
    return get("WMS/getStockoutList", {
      StockOutDateStart: StockOutDateStart,
      StockOutDateEnd: StockOutDateEnd,
      MaterialName: MaterialName,
      Dyelno: Dyelno,
      Color: Color,
      CJO: CJO,
      YardQTY: YardQTY,
      page: page,
      recordCount: recordCount
    });
  },
  /**
   * 获取出库单明细
   */
  getStockoutDetailList(stockOutNum) {
    return get("WMS/getStockOutDetailList", {
      stockOutNum: stockOutNum
    });
  },
  /**
   * 获取待出库单
   */
  getStockOutChoosePackingList(
    Mat_Item_Ref,
    CJO,
    Material,
    Dyelot,
    Color,
    RollCounts,
    Yards,
    InvoiceNo,
    SupplierName,
    LockQTY,
    LockUser,
    Customer,
    page,
    recordCount
  ) {
    return get("WMS/getStockOutChoosePackingList", {
      Mat_Item_Ref: Mat_Item_Ref,
      CJO: CJO,
      Material: Material,
      Dyelot: Dyelot,
      Color: Color,
      RollCounts: RollCounts,
      Yards: Yards,
      InvoiceNo: InvoiceNo,
      SupplierName: SupplierName,
      LockQTY: LockQTY,
      LockUser: LockUser,
      Customer: Customer,
      page: page,
      recordCount: recordCount
    });
  },
  /**
   * 创建出库记录
   */
  createStockOutRecord(isSave, guid, stockoutRecord) {
    return post("WMS/createStockOutRecord", {
      isSave: isSave,
      guid: guid,
      data: stockoutRecord
    });
  },
  /**
   * 作废出库记录
   */
  deleteStockOutRecord(stockOutNum) {
    return post("WMS/deleteStockOutRecord", {
      stockOutNum: stockOutNum
    });
  },
  /**
   * 获取出库报表url
   */
  getStockOutReportUrl(stockOutNum, format = "pdf", inline = false) {
    let reportUrl = `${REPORT_URL_HOST}api/WMSReport/getStockOutReport?stockOutNum=${stockOutNum}&format=${format}&inline=${inline}`;
    let returnUrl = `${
      axios.defaults.baseURL
    }WMSReport/getReport?reportUrl=${urlencode(reportUrl)}`;
    return returnUrl;
  },
  /**
   * 获取待出库布料
   */
  getPackingList(
    StartDate,
    EndDate,
    MaterialName,
    Dyelno,
    Color,
    CJO,
    Mat_Item_Ref,
    ROLLNO,
    page = 1,
    recordCount = 30
  ) {
    return get("WMS/getPackingList", {
      StartDate: StartDate,
      EndDate: EndDate,
      MaterialName: MaterialName,
      Dyelno: Dyelno,
      Color: Color,
      CJO: CJO,
      Mat_Item_Ref: Mat_Item_Ref,
      ROLLNO: ROLLNO,
      page: page,
      recordCount: recordCount
    });
  },

  //发票管理列表
  GetInvoiceList(
    token,
    common,
    search,
    startDt = "",
    endDt = "",
    type = "list",
    page = 1,
    recordCount = 50
  ) {
    if (type === "list") {
      return get("api/Finance/GetInvoiceList", {
        token,
        search,
        common,
        startDt,
        endDt,
        type,
        page,
        recordCount
      });
    } else {
      return `${axios.defaults.baseURL}api/Finance/GetInvoiceList?token=${token}&common=${common}&search=${search}&startDt=${startDt}&endDt=${endDt}&type=${type}&page=${page}&recordCount=${recordCount}`;
    }
  },

  ListByProvider(token, custid) {
    let data = {
      token,
      custid
    };
    return get("api/Finance/GetApplicationPayListByProvider", data);
  },

  AddInvoice(token, data) {
    return post("api/Finance/CreateInvoice", {
      token,
      data
    });
  },

  //发票明细
  GetInvoiceInfo(token, id, invoice = "", custid = 0) {
    return get("api/Finance/GetInvoiceInfo", {
      token,
      id,
      invoice,
      custid
    });
  },

  //删除发票
  InvalidInvoice(token, data) {
    data.remark = "delte";
    return post("api/Finance/InvalidInvoice", {
      token,
      data
    });
  }
};



// WEBPACK FOOTER //
// ./src/request/wmsApi.js